import { FlowBlockState } from 'flow-schema';

import { isDefined } from 'common';

import { type ReactFlowBlockNode } from '../../types';

const ActiveFlowBlockStatePriority: FlowBlockState[] = [
  FlowBlockState.Running,
  FlowBlockState.Waiting,
  FlowBlockState.Queued,
  FlowBlockState.PendingRetry,
];
const ActiveFlowBlockStatePriorityToIndex = Object.fromEntries(
  ActiveFlowBlockStatePriority.map((state, index) => [state, index])
);

/**
 * Returns priority of the active flow block state.
 * The lower the index, the higher the priority, as in P0 is higher than P1.
 * Non-active states are assigned Infinity.
 */
function getActiveFlowBlockStatePriority(node?: ReactFlowBlockNode) {
  const state = node?.data.run?.state;
  if (!isDefined(state) || !(state in ActiveFlowBlockStatePriorityToIndex)) {
    return Infinity;
  }
  return ActiveFlowBlockStatePriorityToIndex[state];
}

export function getActiveRunningBlockNode(blockNodes: ReactFlowBlockNode[]) {
  let activeNode: ReactFlowBlockNode | undefined = undefined;
  for (const node of blockNodes) {
    if (getActiveFlowBlockStatePriority(node) < getActiveFlowBlockStatePriority(activeNode)) {
      activeNode = node;
    }
    if (activeNode?.data.run?.state === ActiveFlowBlockStatePriority[0]) {
      // Found highest priority node, no need to check further
      break;
    }
  }
  return activeNode;
}
